import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { publishReplay, refCount, take } from 'rxjs/operators';
import { Salesperson, SalespersonService as SalesService } from '@vendasta/sales';

@Injectable()
export class SalespersonService {
  private cache: { [salesPersonId: string]: Observable<Salesperson> } = {};

  constructor(private readonly salesService: SalesService) {}

  getSalesperson(partnerId: string, salespersonId: string): Observable<Salesperson> {
    if (!this.cache[salespersonId]) {
      this.cache[salespersonId] = this.salesService
        .getSalesperson(partnerId, salespersonId)
        .pipe(publishReplay(1, 5000), refCount(), take(1));
    }

    return this.cache[salespersonId];
  }
}
